import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared';
import { MrpJobTemplateToProcessTemplateLinkContainerModel } from '../../../../../../models/aggregates/mrp-process';


@Injectable({
  providedIn: 'root'
})
export class JobTemplateToProcessTemplateLinkService extends BaseApiTemplateService<MrpJobTemplateToProcessTemplateLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-template-link/backoffice-ep"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-template-link/backoffice-ep"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-template-link/backoffice-ep"
    this.httpClient = http;
  }

}
